import { render, staticRenderFns } from "./DatabaseReader.vue?vue&type=template&id=7f6d45df"
import script from "./DatabaseReader.vue?vue&type=script&lang=ts"
export * from "./DatabaseReader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports